import { render } from "./ModalDashboardPermissaoCadastro.vue?vue&type=template&id=2ed64792&scoped=true"
import script from "./ModalDashboardPermissaoCadastro.vue?vue&type=script&lang=js"
export * from "./ModalDashboardPermissaoCadastro.vue?vue&type=script&lang=js"

import "./ModalDashboardPermissaoCadastro.vue?vue&type=style&index=0&id=2ed64792&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed64792"],['__file',"src/components/Modal/ModalDashboardPermissaoCadastro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ed64792"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ed64792', __exports__)) {
    console.log('reload')
    api.reload('2ed64792', __exports__)
  }
  
  module.hot.accept("./ModalDashboardPermissaoCadastro.vue?vue&type=template&id=2ed64792&scoped=true", () => {
    console.log('re-render')
    api.rerender('2ed64792', render)
  })

}


export default __exports__